// =====================================================================
// AccountMenu.jsx - Menu compte en haut à droite (style systray Odoo).
// Avatar + nom -> dropdown : statut "En ligne" + "Se déconnecter".
// (Volontairement réduit : pas de Aide / Shortcuts / Préférences / Compte.)
// =====================================================================
import { useState } from 'react';
import { useAuth } from '../hooks/useAuth.jsx';

function initials(name) {
  if (!name) return '?';
  return name.trim().split(/\s+/).slice(0, 2).map((w) => w[0]?.toUpperCase() || '').join('');
}

export default function AccountMenu() {
  const { user, logout } = useAuth();
  const [open, setOpen] = useState(false);

  return (
    <div style={styles.wrap}>
      <button type="button" style={styles.trigger} onClick={() => setOpen((o) => !o)}>
        <span style={styles.avatar}>
          {initials(user?.name)}
          <span style={styles.dot} title="En ligne" />
        </span>
        <span style={styles.name}>{user?.name}</span>
        <span style={styles.caret}>▾</span>
      </button>

      {open && (
        <>
          <div style={styles.backdrop} onClick={() => setOpen(false)} />
          <div style={styles.menu}>
            <div style={styles.menuHead}>
              <div style={styles.menuName}>{user?.name}</div>
              <div style={styles.menuRole}>{user?.role}</div>
            </div>
            <div style={styles.status}>
              <span style={styles.statusDot} /> En ligne
            </div>
            <div style={styles.sep} />
            <button type="button" style={styles.logout} onClick={logout}>
              Se déconnecter
            </button>
          </div>
        </>
      )}
    </div>
  );
}

const styles = {
  wrap: { position: 'relative' },
  trigger: {
    display: 'flex', alignItems: 'center', gap: 9, background: 'transparent', border: 0,
    cursor: 'pointer', padding: '4px 6px', borderRadius: 8, color: '#1f2937',
  },
  avatar: {
    position: 'relative', width: 32, height: 32, borderRadius: '50%', flex: 'none',
    background: '#714B67', color: '#fff', fontSize: '0.72rem', fontWeight: 700,
    display: 'flex', alignItems: 'center', justifyContent: 'center', letterSpacing: '0.02em',
  },
  dot: {
    position: 'absolute', right: -1, bottom: -1, width: 10, height: 10, borderRadius: '50%',
    background: '#22c55e', border: '2px solid #fff',
  },
  name: { fontSize: '0.85rem', fontWeight: 600, maxWidth: 160, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' },
  caret: { fontSize: '0.7rem', color: '#9ca3af' },

  backdrop: { position: 'fixed', inset: 0, zIndex: 40 },
  menu: {
    position: 'absolute', right: 0, top: 'calc(100% + 8px)', zIndex: 50, minWidth: 210,
    background: '#fff', border: '1px solid #e5e7eb', borderRadius: 10,
    boxShadow: '0 10px 30px rgba(0,0,0,0.14)', padding: 6,
  },
  menuHead: { padding: '8px 10px 10px' },
  menuName: { fontSize: '0.88rem', fontWeight: 700 },
  menuRole: { fontSize: '0.72rem', color: '#9ca3af', marginTop: 2 },
  status: { display: 'flex', alignItems: 'center', gap: 8, padding: '6px 10px', fontSize: '0.82rem', color: '#16a34a', fontWeight: 600 },
  statusDot: { width: 9, height: 9, borderRadius: '50%', background: '#22c55e' },
  sep: { height: 1, background: '#f0f0f3', margin: '4px 0' },
  logout: {
    width: '100%', textAlign: 'left', background: 'transparent', border: 0, cursor: 'pointer',
    padding: '8px 10px', borderRadius: 7, fontSize: '0.85rem', color: '#b91c1c', fontWeight: 600,
  },
};
